import debounce from 'lodash/debounce';
import { FAST_TIMER } from '~/const/timers';
export default {
  data() {
    return {
      initialPageYOffset: 0
    };
  },

  methods: {
    handleScroll: debounce(function handleDebounche() {
      window.scrollTo(0, this.initialPageYOffset);
    }, FAST_TIMER),

    disableWindowScroll() {
      if (this.isMobile()) {
        window.document.querySelector('body').style.overflow = 'hidden';
        return;
      }

      this.initialPageYOffset = window.pageYOffset;
      window.addEventListener('scroll', this.handleScroll, false);
    },

    enableWindowScroll() {
      window.document.querySelector('body').style.overflow = '';
      window.removeEventListener('scroll', this.handleScroll, false);
    }

  }
};